// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20PJE","comment":"styles_comment__OLoxZ"};